import { Component, OnInit } from '@angular/core';
import { BettingServiceService } from 'src/app/services/betting_service/betting-service.service';
import { ModalController } from '@ionic/angular';
import { StmgService } from '../../../../services/state_Management/stmg.service';
import { CommonServiceService } from '../../../../services/common_service/common-service.service';
import { AlertController } from '@ionic/angular';
import { AlertComponent } from '../../../../components/alert/alert.component';
import videojs from 'video.js';
import { TranslateService } from '@ngx-translate/core';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-lucky-loot',
  templateUrl: './lucky-loot.component.html',
  styleUrls: ['./lucky-loot.component.scss'],
})
export class LuckyLootComponent implements OnInit {

  rouletteVideoUrl: any;
  player: any;
  kironSelections: any = []; // store selections from service
  numbers: number[] = Array.from({ length: 24 }, (_, i) => i + 1);
  selectedNumbers: number[] = [];
  selectedAll = [];
  selectedAllBoxes = [];
  firstClicked: boolean = false; 
  resultBoxes = [
    { label: '1ST COLOUR', color: 'white', number: '', value: '3.6' },
    { label: '1ST BALL', color: 'white', number: '', value: '21' }
  ];

  repeatOptions: number[] = [1, 2, 3, 4, 5];
  repeatCount = 1;

  timerDisplay: string;
  // private timer: any;
  // private totalSeconds: number = 120;

  meetingPayload = {
    country: 'KR7',
    date: this.commanService.getCurrentDateTime(),
    filter: 1,
    inplay: false,
    sport: 'VR',
  }

  selectedBets = new Set<string>();
  betSlips: string[] = [];
  selection: any = {
    "payload": {
      "@rule": "FeedId87BettingOptions",
      eventSelections: []
    }
  };
  clickCounts: { [key: string]: number } = {};
  maxCount = false;
  selectionType: string = 'SP';

  disable_SP_subscription: Subscription;
  subscription: Subscription;
  mySubscription: Subscription;

  kironNewData: any;
  is_logged = false;
  NextDrowEventCode: string;
  CurrentEventName: string;
  kironResults: any = [];
  selectedSumDraws = [];

  currentSelectedBets: any = null;    // Block other races selections

  constructor( public modalController: ModalController, public betting_service: BettingServiceService, public translate: TranslateService,
    private commanService: CommonServiceService, private stmgService: StmgService, public alertController: AlertController) {
      //refresh when remove all from bet slip modal
    this.disable_SP_subscription = this.commanService.getClickEvent().subscribe(() => {
      this.clearSelection();
    });

    this.stmgService.updateSelections$.subscribe((selection:any) => {    
      if(selection && !Array.isArray(selection)){

        if (this.columns?.length) {
          this.columns.forEach(column => {
            column.forEach(box => {
              if(Number(selection.id) == box.id){
                box.selected = false;
                this.selectedAllBoxes = this.selectedAllBoxes.filter(b => b.id != box.id);
              }
            });
          });
        }
        if (this.sumDraws?.length) {
          this.sumDraws.forEach(item => {
            if(Number(selection.id) == item.id){
              item.selected = false;
              this.selectedAllBoxes = this.selectedAllBoxes.filter(b => b.id != item.id);
              this.selectedSumDraws = this.selectedSumDraws.filter(sod => sod.id != item.id);
            }
          });
        }
      }else if(selection && Array.isArray(selection)){
        selection.forEach((s:any) => {
          this.selectedNumbers = this.selectedNumbers.filter(num => num != Number(s.selectionNumber))
          this.selectedAll = this.selectedAll.filter(item => item.number != Number(s.selectionNumber))
        })
      }
    });
  } 


  columns: any[][] = [];
  sumDraws: any[] = [];

  ngOnInit() {
    // this.luckeyLootVideoUrl = this.betting_service.getLuckyLootVideoUrl();
    this.stmgService.is_logged_status.subscribe(message => {
      this.is_logged = message;
      // If logged in, initialize video player
      if (this.is_logged) {
        this.initVideoPlayer();
      }
    });

    // get Kiron Meetings
    this.kiron_getMeetings();
    this.get_kiron_results();
    
    this.stmgService.is_logged_status.subscribe(message =>
      this.is_logged = message
    );

    // this.subscription = this.stmgService.cast_selectedBets.subscribe(selectedBets => {
    //   if (selectedBets) {
    //     this.selection = selectedBets;
    //   }
    // });

    // Block other races selections
    this.stmgService.cast_selectedBets.subscribe(bets => {
      this.currentSelectedBets = bets;
    });

  }

  initVideoPlayer() {
    this.betting_service.getKiron7VideoUrl(this.commanService.getToken()).subscribe((res: any) => {

      // Adjust this according to your API response structure
      this.rouletteVideoUrl = res?.url || res?.videoUrl || res?.data?.url;

      if (!this.rouletteVideoUrl) {
        console.error('Video URL not found in response');
        return;
      }

      setTimeout(() => {
        if (this.player) {
          this.player.dispose();
        }

        this.player = videojs('video-player', {
          controls: true,
          autoplay: false,
          preload: 'auto',
          fluid: true,
          techOrder: ['html5'],
          html5: {
            hls: {
              overrideNative: true,
              withCredentials: false,
            },
            nativeAudioTracks: false,
            nativeVideoTracks: false,
          },
        });

        this.player.src(
          this.rouletteVideoUrl.includes('.m3u8')
            ? { type: 'application/x-mpegURL', src: this.rouletteVideoUrl }
            : { type: 'video/mp4', src: this.rouletteVideoUrl }
        );

        this.player.load();
      }, 0);

    }, error => {
      console.error('Error getting video URL:', error);
    });
  }

  // Video click handler
  onVideoClick() {
    if (!this.is_logged) {
      let alertTitle: string; 
      let alertDesc: string;

      this.translate.get('ALERTS.LOGTO_VIDEO.TITLE').subscribe(res => alertTitle = res);
      this.translate.get('ALERTS.LOGTO_VIDEO.DESC').subscribe(res => alertDesc = res);

      const alert = new AlertComponent(this.alertController);
      alert.loginSuccessAlert("", alertTitle, alertDesc);
    }
  }
  
  //stop the loop
  ngOnDestroy() {

    if (this.player) {
      this.player.dispose(); // clean up
    }
    this.mySubscription?.unsubscribe();
    console.log("unsubsccribe")
    this.disable_SP_subscription.unsubscribe();
  }

  //kiron result method
  get_kiron_results() {
    this.betting_service.getKiron7Result().subscribe(
      (data) => {
        this.kironResults = data[0].events;
        this.kironResults = this.kironResults.reverse();
        // console.log("Keno results: ",  data);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  checkBallColor(item: any) {
    // Normal color detection
    const colors = ['red', 'green', 'blue', 'yellow'];
    for (let color of colors) {
      if (item.selectionName?.toLowerCase().includes(color)) {
        return color;
      }
    }
    return "noColor";
  }

  // get Kiron Meetings
  kiron_getMeetings() {
    this.betting_service.getLuckyLootMeetingDataById(this.meetingPayload).subscribe((data: any) => {
      this.kironGetEventStartTime(data.payload[0].eventLightDTOs);
      this.GetNextDrowEventCode(data.payload[0].eventLightDTOs);
      // console.log("Meeting Response Lucky Loot: ", data);
      this.kiron_data(data);
    });
  }


  // get 0th Item from eventLightDTOs
  kiron_data(d: any) {
    let kironMeetings_Data: any = null;
    if (d.status === 'success' && d.payload.length > 0) {
      const events = d.payload[0].eventLightDTOs;
      if (events && events.length > 0) {
        // Get only the 0th item
        kironMeetings_Data = events[0];
      }
    }
    this.getKironsEventByID(kironMeetings_Data);
  }

  // getKironsEventByID(d: any) {
  //   let kironEventresult = Array.isArray(d) ? d : (d ? [d] : []);
  //   kironEventresult.forEach(event => {
  //     if (event?.id) {
  //       event.selections = [];
  //       this.betting_service.getEventSelections(event.id).subscribe((data) => {
  //         this.GetEventName(data);
  //         event.selections = data;
  //         this.kironSelections = data; 
  //       });
  //     }
  //   });
  //   this.kironNewData = kironEventresult;
  // }
   
  // Process service data and build columns and sumDraws
  getKironsEventByID(d: any) {
    let kironEventresult = Array.isArray(d) ? d : (d ? [d] : []);
    
    kironEventresult.forEach(event => {
      if (event?.id) {
        event.selections = [];
        this.betting_service.getEventSelections(event.id).subscribe((data: any) => {
          this.GetEventName(data);
          event.selections = data;
          this.kironSelections = Array.isArray(data) ? data : [];
          
          // Build columns and sumDraws from service data
          this.buildColumnsFromData(this.kironSelections);
          this.buildSumDrawsFromData(this.kironSelections);
        });
      }
    });
    
    this.kironNewData = kironEventresult;
  }

  // Get event start time.
  kironGetEventStartTime(meeting) {
    this.betting_service.eventStartTime(meeting[0].id).subscribe((data) => {
      this.kironEventStartTime(data);
    }
    );
  }

  kironEventStartTime(data) {
    let time = Math.round(data.timeToStartMillis / 1000);

    // clamp starting value
    time = Math.max(time, 0);

    this.timerDisplay = this.formatTime(time);

    // clear previous timer
    if (this.mySubscription) {
      this.mySubscription.unsubscribe();
    }

    this.mySubscription = interval(1000).subscribe(() => {

      time = time - 1;
      time = Math.max(time, 0);  

      this.timerDisplay = this.formatTime(time);

      if (time === 0) {
        this.mySubscription.unsubscribe();
        this.kiron_getMeetings();
        this.resetAllSelections();
        return;
      }

    });
  }

  // Time format
  private formatTime(seconds: number): string {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;

    if (h > 0) {
      return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
    }

    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  }

  GetNextDrowEventCode(data:any){
    this.NextDrowEventCode = data[0].eventCode;
  }

  GetEventName(data: any){
    this.CurrentEventName = data[0].eventName;
  }

  // startTimer() {
  //   clearInterval(this.timer);
  //   this.totalSeconds = 120;

  //   this.timer = setInterval(() => {
  //     if (this.totalSeconds <= 0) {
  //       clearInterval(this.timer);
  //       this.timerDisplay = '00:00';
        
  //       // Restart automatically
  //       this.startTimer();
  //       this.resetAllSelections();
  //       return;
  //     }

  //     this.totalSeconds--;

  //     const minutes = Math.floor(this.totalSeconds / 60);
  //     const seconds = this.totalSeconds % 60;

  //     this.timerDisplay =
  //       (minutes < 10 ? '0' + minutes : minutes) +
  //       ':' +
  //       (seconds < 10 ? '0' + seconds : seconds);
  //   }, 1000);
  // }

  resetAllSelections() {
    this.selectedNumbers = [];
    this.selectedAll = [];       // toggleSelect + quickPick UI
    this.selectedAllBoxes = [];  // toggleBox + toggleSumDraw
    this.selectedBets.clear();
    this.betSlips = [];

    this.selection = {
      payload: {
        "@rule": "FeedId87BettingOptions",
        eventSelections: []
      }
    };

    this.ensurePayload();

    this.clickCounts = {};
    this.firstClicked = false;

    if (this.columns?.length) {
      this.columns.forEach(column => {
        column.forEach(box => {
          box.selected = false;
        });
      });
    }
    if (this.sumDraws?.length) {
      this.sumDraws.forEach(item => {
        item.selected = false;
      });
    }

    this.resultBoxes = [
      { label: '1ST COLOUR', color: 'white', number: '', value: '3.6' },
      { label: '1ST BALL',   color: 'white', number: '', value: '21' }
    ];

    const empty_array = {
      eventSelections: []
    };

    // this.stmgService.updateSelecteBets(this.selection);
    this.stmgService.updateSelecteBets(empty_array);
  }
  
  // Helper function to extract color from name
  private extractColorFromName(name: string): string {
    const lowerName = name.toLowerCase();
    if (lowerName.includes('green')) return 'green';
    if (lowerName.includes('blue')) return 'blue';
    if (lowerName.includes('yellow')) return 'yellow';
    if (lowerName.includes('red')) return 'red';
    return 'green'; // default
  }

  // Build columns array from service data
  private buildColumnsFromData(data: any[]) {
    // Initialize 5 columns for "0", "2+", "3+", "4+", "5+"
    this.columns = [[], [], [], [], []];
    
    // Group selections
    const grouped: { [key: string]: any[] } = {
      '0': [],
      '2+': [],
      '3+': [],
      '4+': [],
      '5+': []
    };
    
    // Default small numbers for each column type
    const defaultSmallNumbers: { [key: string]: string } = {
      '0': '6',
      '2+': '1.9',
      '3+': '6',
      '4+': '45',
      '5+': '700'
    };
    
    // Process each selection
    data.forEach(selection => {
      const name = selection.name;

      if (name.includes(' 0')) {
        grouped['0'].push(selection);
      } else if (name.includes(' 2+')) {
        grouped['2+'].push(selection);
      } else if (name.includes(' 3+')) {
        grouped['3+'].push(selection);
      } else if (name.includes(' 4+')) {
        grouped['4+'].push(selection);
      } else if (name.includes(' 5+')) {
        grouped['5+'].push(selection);
      }
    });
    
    // Define color order
    const colorOrder = ['green', 'blue', 'yellow', 'red'];
    
    // Build each column
    Object.keys(grouped).forEach((key, colIndex) => {
      const items = grouped[key];
      
      // Sort by color order
      items.sort((a, b) => {
        const colorA = this.extractColorFromName(a.name);
        const colorB = this.extractColorFromName(b.name);
        return colorOrder.indexOf(colorA) - colorOrder.indexOf(colorB);
      });
      
      // Add to respective column
      items.forEach(item => {
        const color = this.extractColorFromName(item.name);
        const displayText = key;
        
        this.columns[colIndex].push({
          circleText: displayText,
          circleColor: color,
          smallNumber: defaultSmallNumbers[key],
          mainNumber: '', 
          color: color,
          name: item.name,
          selectionNumber: item.selectionNumber.toString(),
          selected: false,
          id: item.id,
          eventId: item.eventId,
          eventCode: item.eventCode,
          meetingName: item.meetingName,
          eventName: item.eventName,
          countryCode: item.countryCode
        });
      });
    });
  }

  // Build sumDraws array from service data
  private buildSumDrawsFromData(data: any[]) {
    this.sumDraws = [];
    
    // Find SOD selections
    const sodSelections = data.filter(s => s.name.startsWith('SOD'));
    
    sodSelections.forEach(selection => {
      const name = selection.name;
      let label = '';
      let displayName = '';
      let value = '';
      
      if (name.includes('Odd')) {
        label = 'ODD';
        displayName = 'ODD';
        value = '1.9';
      } else if (name.includes('Even')) {
        label = 'EVEN';
        displayName = 'EVEN';
        value = '1.9';
      } else if (name.includes('Over')) {
        label = 'OVER 75.5';
        displayName = 'OVER';
        value = '1.9';
      } else if (name.includes('Under')) {
        label = 'UNDER 75.5';
        displayName = 'UNDER';
        value = '1.9';
      }
      
      if (label) {
        this.sumDraws.push({
          label: label,
          value: value,
          name: displayName,
          selectionNumber: selection.selectionNumber.toString(),
          selected: false,
          id: selection.id,
          eventId: selection.eventId,
          eventCode: selection.eventCode,
          meetingName: selection.meetingName,
          eventName: selection.eventName,
          countryCode: selection.countryCode
        });
      }
    });
  }

  // Toggle number selection (for 1-24 numbers)
  toggleSelect(num: number, index: number) { 
    if (!this.is_logged) {
      this.loginAlert();
      return;
    }

    if (this.blockGameSelection()) return;

    const color = this.getColor(index);
    const totalSelections = this.selectedNumbers.length + this.selectedAllBoxes.length + this.selectedSumDraws.length;

    if (!this.selectedNumbers.includes(num) && this.selectedNumbers.length >= 6) {
      this.showMaxCountAlert();
      return;
    }

    if (this.selectedNumbers.includes(num)) {
      this.selectedNumbers = this.selectedNumbers.filter(n => n !== num);
      this.selectedAll = this.selectedAll.filter(n => n.number !== num);
    } else {
      this.selectedNumbers.push(num);
      this.selectedAll.push({ number: num, color });
    }

    this.updateFirstClick(color, num);
    this.updateBetSlips();
  }

  // Quick pick
  quickPick(pick: number) {
    if (!this.is_logged) {
      this.loginAlert();
      return;
    }

    if (this.blockGameSelection()) return;

    if (pick > 6) pick = 6;

    const totalSelections = this.selectedNumbers.length + this.selectedAllBoxes.length + this.selectedSumDraws.length;

    // if (totalSelections >= 20) {
    //   this.showCountAlert();
    //   return;
    // }
    
    const spaceLeft = 20 - totalSelections;
    if (pick > spaceLeft) {
      pick = spaceLeft;
    }

    this.selectedNumbers = [];
    this.selectedAll = [];
    this.firstClicked = false;

    while (this.selectedNumbers.length < pick) {
      const random = Math.floor(Math.random() * 24) + 1;

      if (!this.selectedNumbers.includes(random)) {
        this.selectedNumbers.push(random);
        const color = this.getColor(random - 1);
        this.selectedAll.push({ number: random, color });
      }
    }

    if (this.selectedAll.length > 0) {
      const first = this.selectedAll[0];
      this.firstClicked = true;
      this.resultBoxes[0].color = first.color;
      this.resultBoxes[1].color = first.color;
      this.resultBoxes[1].number = first.number.toString();
    }

    this.updateBetSlips();
  }

  // Toggle Box selection (for columns: 0, 2+, 3+, 4+, 5+)
  toggleBox(box: any) {

    if (!this.is_logged) {
      this.loginAlert();
      return;
    }

    if (this.blockGameSelection()) return;

    const selectionNum = box.selectionNumber;
    if (!selectionNum) {
      console.error('No selectionNumber in box:', box);
      return;
    }

    // from the color boxes we can select only 1 box from a column  
    // this.selectedAllBoxes.forEach(boxSelected => {
    //   if(boxSelected.name.split(' ')[1] == box.name.split(' ')[1]){
    //     this.columns.forEach(column => {
    //       column.forEach(box => {
    //         if(box.id == boxSelected.id){
    //           box.selected = false;
    //         }
    //       });
    //     });
    //     this.selectedAllBoxes = this.selectedAllBoxes.filter(
    //       x => x.selectionNumber !== boxSelected.selectionNumber
    //     );
    //   }
    // })

    const totalSelections = 
      this.selectedNumbers.length + 
      this.selectedAllBoxes.length + 
      this.selectedSumDraws.length;

    // if (!box.selected && totalSelections >= 20) {
    //   this.showCountAlert();
    //   return;
    // }

    if (!box.selected && this.selectedAllBoxes.length >= 4) {
      this.showColorCountAlert();
      return;
    }
    
    box.selected = !box.selected;

    if (box.selected) {
      this.selectedAllBoxes.push({ 
        selectionNumber: box.selectionNumber,
        name: box.name,
        circleColor: box.circleColor,
        color: box.color,
        id: box.id,
        eventId: box.eventId,
        eventCode: box.eventCode,
        meetingName: box.meetingName,
        eventName: box.eventName,
        countryCode: box.countryCode
      });
    } else {
      this.selectedAllBoxes = this.selectedAllBoxes.filter(
        x => x.selectionNumber !== selectionNum
      );
    }

    this.updateBetSlips();
  }

  // Toggle Sum Draw selection
  toggleSumDraw(item: any, index: number) {
    if (!this.is_logged) {
      this.loginAlert();
      return;
    }

    if (this.blockGameSelection()) return;

    // from the odd/even we can select only 1 and from the  over/under we can select only 1
    // this.selectedSumDraws.forEach(sod => {
    //   if(sod.name == "ODD" || sod.name == "EVEN"){
    //     if(item.name == "ODD" || item.name == "EVEN"){
    //       this.sumDraws.forEach(item => {
    //         if(item.id == sod.id){
    //           item.selected = false;
    //         }
    //       });
          
    //       this.selectedSumDraws = this.selectedSumDraws.filter(
    //         x => x.id !== sod.id
    //       );
    //     }
    //   }

    //   if(sod.name == "UNDER" || sod.name == "OVER"){
    //     if(item.name == "UNDER" || item.name == "OVER"){
    //       this.sumDraws.forEach(item => {
    //         if(item.id == sod.id){
    //           item.selected = false;
    //         }
    //       });
          
    //       this.selectedSumDraws = this.selectedSumDraws.filter(
    //         x => x.id !== sod.id
    //       );
    //     }
    //   }
    // })
    
    const totalSelections = 
      this.selectedNumbers.length + 
      this.selectedAllBoxes.length + 
      this.selectedSumDraws.length;

    // if (!item.selected && totalSelections >= 20) {
    //   this.showCountAlert();
    //   return;
    // }

    item.selected = !item.selected;

    if (item.selected) {
      this.selectedSumDraws.push({
        selectionNumber: item.selectionNumber,
        name: item.name,
        label: item.label,
        id: item.id,
        eventId: item.eventId,
        eventCode: item.eventCode,
        meetingName: item.meetingName,
        eventName: item.eventName,
        countryCode: item.countryCode
      });
    } else {
      this.selectedSumDraws = this.selectedSumDraws.filter(
        x => x.selectionNumber !== item.selectionNumber
      );
    }
    this.updateBetSlips();
  }

  // Update Bet slips
  private updateBetSlips() {
    this.ensurePayload();
    this.betSlips = [];
    this.selection.payload.eventSelections = [];

    // Regular Number Selections (1-24)
    if (this.selectedNumbers.length > 0) {
      this.selectedNumbers.forEach(num => {
        const number = Number(num);
        this.betSlips.push(number.toString());
        const found = this.kironSelections.find(s => Number(s.selectionNumber) === number);

        if (found) {
          this.selection.payload.eventSelections.push({
            id: found.id,
            eventId: found.eventId,
            name: found.name,
            eventCode: found.eventCode,
            meetingName: found.meetingName,
            eventName: found.eventName,
            selectionNumber: found.selectionNumber,
            countryCode: found.countryCode,
          });
        }
      });
    }

    // BOX selections (columns)
    if (this.selectedAllBoxes.length > 0) {
      this.selectedAllBoxes.forEach(box => {
        const displayName = box.name;
        this.betSlips.push(displayName);

        this.selection.payload.eventSelections.push({
          id: box.id,
          eventId: box.eventId,
          name: box.name,
          eventCode: box.eventCode,
          meetingName: box.meetingName,
          eventName: box.eventName,
          selectionNumber: box.selectionNumber,
          countryCode: box.countryCode,
        });
      });
    }

    // SUM DRAW selections
    if (this.selectedSumDraws.length > 0) {
      this.selectedSumDraws.forEach(sd => {
        this.betSlips.push(sd.label);

        // Find the actual selection from kironSelections
        const found = this.kironSelections.find(s => 
          s.selectionNumber.toString() === sd.selectionNumber
        );

        if (found) {
          this.selection.payload.eventSelections.push({
            id: found.id,
            eventId: found.eventId,
            name: found.name,
            eventCode: found.eventCode,
            meetingName: found.meetingName,
            eventName: found.eventName,
            selectionNumber: found.selectionNumber,
            countryCode: found.countryCode,
          });
        }
      });
    }

    this.stmgService.updateSelecteBets(this.selection);
  }

  // Block Other selections
  blockGameSelection(): boolean {

    // Block other races selections
     if (this.currentSelectedBets && this.currentSelectedBets !== '') {
        // console.log('Lucky Loot - Inside check, currentBets exists');
       
        let hasPayload;

        if(this.currentSelectedBets?.payload){
          hasPayload = this.currentSelectedBets.payload['@rule'] === 'FeedId87BettingOptions';
        }else{
          hasPayload = false;
        }

        // console.log('Has Lucky Loot Selections :', hasPayload);
       
       if (!hasPayload) {
          let hasRaceBets;

          if(this.currentSelectedBets?.payload){
            hasRaceBets = this.currentSelectedBets.payload.eventSelections.length > 0;
          }else{
            hasRaceBets = this.currentSelectedBets.eventSelections.length > 0;
          }
         
          // console.log('Game - Has Racing or other game Bets:', hasRaceBets);
         
         if (hasRaceBets) {
           this.showBlockAlert();
           return true;
         }
       }
     }

     return false;
  }

  // Block Other Races
  showBlockAlert() {
    let alertTitle: string;
    let alertDesc: string;
    this.translate.get('ALERTS.BLOCK_SELECTIONS.TITLE').subscribe((res: string) => {
      alertTitle = res;
    });
    this.translate.get('ALERTS.BLOCK_SELECTIONS.DESC').subscribe((res: string) => {
      alertDesc = res;
    });
    let alert = new AlertComponent(this.alertController);
    alert.launchAlert("", alertTitle, alertDesc);
  }

  private updateFirstClick(color: string, num: number) {
    if (!this.firstClicked) {
      this.firstClicked = true;
      this.resultBoxes[0].color = color;
      this.resultBoxes[1].color = color;
      this.resultBoxes[1].number = num.toString();
    }
  }

  // Remove from bet slip
  removeFromBetSlip(value: string) {
    this.betSlips = this.betSlips.filter(b => b !== value);
    const numValue = Number(value);
    if (!isNaN(numValue)) {
      this.selectedNumbers = this.selectedNumbers.filter(n => n !== numValue);
    }
    this.selectedAllBoxes = this.selectedAllBoxes.filter(
      x => (x.label || x.name) !== value
    );
    this.updateBetSlips();
  }


  // check max count
  checkMaximuSelectionCount(): boolean {
    const selectionArray = this.betSlips.filter(m => Number(m) >= 0 );
    return selectionArray.length >= 6;
    this.showMaxCountAlert();
  }

  getColor(index: any): string {
    const value = Number(index);

    const cols = 6;
    const row = Math.floor(value / cols) + 1;
    const col = (value % cols) + 1;

    if (col % 2 !== 0) {
      return row <= 2 ? 'green' : 'blue';
    } else {
      return row <= 2 ? 'yellow' : 'red';
    }
  }

  checkBonusBall(position: any, bonsuBall: any) {
    return position.selectionNumber == Number(bonsuBall);
  }

  // Check if a number is toggled
  isSelected(index: string): boolean {
    return this.selectedBets.has(index);
  }

  ensurePayload() {
    // If selection is totally undefined - create full object
    if (!this.selection) {
      this.selection = {
        payload: {
          "@rule": "FeedId87BettingOptions",
          eventSelections: []
        }
      };
    }

    // If payload missing - recreate with rule
    if (!this.selection.payload) {
      this.selection.payload = {
        "@rule": "FeedId87BettingOptions",
        eventSelections: []
      };
    }

    // If rule missing - add it
    if (!this.selection.payload["@rule"]) {
      this.selection.payload["@rule"] = "FeedId87BettingOptions";
    }

    // If wrong root eventSelections exists - remove it
    if (this.selection.eventSelections) {
      delete this.selection.eventSelections;
    }

    // Ensure array exists
    if (!Array.isArray(this.selection.payload.eventSelections)) {
      this.selection.payload.eventSelections = [];
    }
  }

  clearSelection() {
    this.selectedNumbers = [];
    this.selectedAll = [];
    this.selectedAllBoxes = [];
    this.selectedSumDraws = [];
    this.selectedBets.clear();
    this.betSlips = [];

    this.selection = {
      payload: {
        "@rule": "FeedId87BettingOptions",
        eventSelections: []
      }
    };

    this.ensurePayload();

    this.clickCounts = {};
    this.firstClicked = false;

    if (this.columns?.length) {
      this.columns.forEach(column => {
        column.forEach(box => {
          box.selected = false;
        });
      });
    }

    if (this.sumDraws?.length) {
      this.sumDraws.forEach(item => {
        item.selected = false;
      });
    }

    this.resultBoxes = [
      { label: '1ST COLOUR', color: 'white', number: '', value: '3.6' },
      { label: '1ST BALL',   color: 'white', number: '', value: '21' }
    ];

    const empty_array = {
      eventSelections: []
    };

    this.stmgService.updateSelecteBets(empty_array);
  }

  // Alerts
  loginAlert() {
    let alertTitle: string;
    let alertDesc: string;
    this.translate.get('ALERTS.PLEASE_LOG.TITLE').subscribe((res: string) => {
      alertTitle = res;
    });
    this.translate.get('ALERTS.PLEASE_LOG.DESC').subscribe((res: string) => {
      alertDesc = res;
    });
    let alert = new AlertComponent(this.alertController);
    alert.launchAlert(
      "", alertTitle, alertDesc
    ); 
  }

  showMaxCountAlert() {
    let alertTitle: string;
    let alertDesc: string;
    this.translate.get('ALERTS.MAX_COUNT_LOOT.TITLE').subscribe((res: string) => {
      alertTitle = res;
    });
    this.translate.get('ALERTS.MAX_COUNT_LOOT.DESC').subscribe((res: string) => {
      alertDesc = res;
    });
    let alert = new AlertComponent(this.alertController);
    alert.launchAlert("", alertTitle, alertDesc);
  }

  // showCountAlert() {
  //   let alertTitle: string;
  //   let alertDesc: string;
  //   this.translate.get('ALERTS.MAX_COUNT_LOOT2.TITLE').subscribe((res: string) => {
  //     alertTitle = res;
  //   });
  //   this.translate.get('ALERTS.MAX_COUNT_LOOT2.DESC').subscribe((res: string) => {
  //     alertDesc = res;
  //   });
  //   let alert = new AlertComponent(this.alertController);
  //   alert.launchAlert("", alertTitle, alertDesc);
  // }

  showColorCountAlert() {
    let alertTitle: string;
    let alertDesc: string;
    this.translate.get('ALERTS.MAX_COUNT_LOOT_COLORS.TITLE').subscribe((res: string) => {
      alertTitle = res;
    });
    this.translate.get('ALERTS.MAX_COUNT_LOOT_COLORS.DESC').subscribe((res: string) => {
      alertDesc = res;
    });
    let alert = new AlertComponent(this.alertController);
    alert.launchAlert("", alertTitle, alertDesc);
  }

  showPriceTable = false;

  openPriceTable() {
    this.showPriceTable = true;
  }

  closePriceTable() {
    this.showPriceTable = false;
  }
}
